import { jsx as _jsx } from "react/jsx-runtime";
import { Alert, keyframes, Snackbar } from '@mui/material';
const debug = process.env.REACT_APP_DEBUG && false;
/** the base z-index to start from */
const baseZIndex = 1000;
/** how many  notifications to show (or imply) when collapsed */
const show = 3;
/** height to offset by whe collapsed */
const height = 48;
export default function UserMessage({ message, onClose, collapsed, index }) {
    const first = index === 0;
    const hide = collapsed && show <= index;
    const alert = (_jsx(Alert, { elevation: collapsed ? Math.max(6 - index, 0) : 6, variant: "filled", severity: message.severity, onClose: onClose, sx: {
            position: 'relative',
            top: collapsed && !first ? index * -height : 0,
            left: 0,
            right: 0,
            marginInline: collapsed ? index : 0,
            zIndex: baseZIndex - index,
            pointerEvents: hide ? 'none' : undefined,
            opacity: hide ? 0 : 1,
            transitionProperty: first ? 'margin-inline, opacity' : 'top, margin-inline, opacity',
            transitionDelay: collapsed ? '0' : `calc(${index} * 0.05s)`,
            transitionDuration: '0.2s',
            transitionTimingFunction: 'ease-in-out',
            animation: `${slideIn} 0.3s ease-in-out 1`,
        }, children: message.content }));
    if (message?.type === 'SnackBar')
        return _jsx(Snackbar, { open: true, autoHideDuration: 6000, onClose, children: alert });
    return alert;
}
const slideIn = keyframes `
  0% {
    top: -5em;
  }
  100% {
    top: 0;
  }
`;
